import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Product_details_swiper.css";
import Best_seller_heart from "../../common-components/product_card/Best_seller_heart/Best_seller_heart";
import { variant_type } from "../../../utils/common";
import "react-medium-image-zoom/dist/styles.css";

function Product_details_swiper({ product, selectedVariant }) {
  const [activeImage, setActiveImage] = useState("");
  const IMG_BASE_URL = process.env.REACT_APP_IMG_URL;

  // Sync active image with variant changes
  useEffect(() => {
    if (
      product?.variant_type_id === variant_type.Single &&
      selectedVariant?.Product_Images?.length > 0
    ) {
      setActiveImage(selectedVariant.Product_Images[0].image);
    } else if (
      Number(product?.variant_type_id) === Number(variant_type.Double) &&
      selectedVariant?.Product_Variant?.Product_Images?.length > 0
    ) {
      console.log(
        selectedVariant.Product_Variant?.Product_Images[0].image,
        "selectedVariant.Product_Variant?.Product_Images[0].image",
      );

      setActiveImage(selectedVariant.Product_Variant?.Product_Images[0].image);
    } else if (
      Number(product?.variant_type_id) === variant_type.Triple &&
      selectedVariant?.Double_Variant?.Product_Variant?.Product_Images?.length >
        0
    ) {
      setActiveImage(
        selectedVariant.Double_Variant?.Product_Variant?.Product_Images[0]
          .image,
      );
    } else if (product?.image) {
      setActiveImage(product.image);
    }
  }, [selectedVariant, product]);

  class Zoomable {
    constructor(element, config) {
      this.element = element;
      this.config = this._mergeConfig(config);

      const { initialZoom, minZoom, maxZoom } = this.config;

      this.zoomed = false;
      this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
      this.zoom = this.initialZoom;

      this.img = element.querySelector(".zoomable__img");
      this.img.draggable = false;
      this.element.style.setProperty("--zoom", this.initialZoom);

      this._addEventListeners();
    }

    static get Default() {
      return Default;
    }

    _addEventListeners() {
      this.element.addEventListener("mouseenter", () =>
        this._handleMouseover(),
      );
      this.element.addEventListener("mousemove", (evt) =>
        this._handleMousemove(evt),
      );
      this.element.addEventListener("mouseleave", () => this._handleMouseout());
      this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));
    }

    _handleMouseover() {
      if (this.zoomed) {
        return;
      }

      this.element.classList.add("zoomable--zoomed");
      this.zoomed = true;
    }

    _handleMousemove(evt) {
      if (!this.zoomed) {
        return;
      }

      const elPos = this.element.getBoundingClientRect();
      const percentageX = `${((evt.clientX - elPos.left) * 100) /
        elPos.width}%`;
      const percentageY = `${((evt.clientY - elPos.top) * 100) /
        elPos.height}%`;

      this.element.style.setProperty("--zoom-pos-x", percentageX);
      this.element.style.setProperty("--zoom-pos-y", percentageY);
    }

    _handleMouseout() {
      if (!this.zoomed) {
        return;
      }

      this.element.style.setProperty("--zoom", this.initialZoom);
      this.element.classList.remove("zoomable--zoomed");
      this.zoomed = false;
    }

    _handleWheel(evt) {
      if (!this.zoomed) {
        return;
      }

      evt.preventDefault();

      const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
      const { minZoom, maxZoom } = this.config;

      this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
      this.element.style.setProperty("--zoom", this.zoom);
    }

    _mergeConfig(config) {
      return {
        ...this.constructor.Default,
        ...(typeof config === "object" ? config : {}),
      };
    }
  }

  const Default = {
    initialZoom: 3,
    minZoom: 1.25,
    maxZoom: 4,
    zoomSpeed: 0.01,
  };

  const zoomableRef = useRef(null);

  useEffect(() => {
    const element = zoomableRef.current;
    if (!element) return;

    const zoomable = new Zoomable(element);

    return () => {
      element.removeEventListener("mouseenter", zoomable._handleMouseover);
      element.removeEventListener("mousemove", zoomable._handleMousemove);
      element.removeEventListener("mouseleave", zoomable._handleMouseout);
      element.removeEventListener("wheel", zoomable._handleWheel);
    };
  }, []);

  return (
    <section className="Product_details_swiper">
      <div className="main_img_holder">
        {/* We use a key here so the zoom resets when the image changes */}
        <div
          className="magnify_container"
          // key={activeImage}
          ref={zoomableRef}
        >
          <img src={IMG_BASE_URL + activeImage} className="zoomable__img" />
        </div>

        <div className="wishlist_div">
          <Best_seller_heart product={product} />
        </div>
      </div>

      <div className="swiper_holder">
        <Swiper
          slidesPerView={5}
          spaceBetween={10}
          className="Product_details_Swiper_holder"
        >
          {Number(product?.variant_type_id) === variant_type.Single &&
            selectedVariant?.Product_Images?.map((val, index) => (
              <SwiperSlide
                key={index}
                onClick={() => setActiveImage(val.image)}
              >
                <div
                  className={`img_holder ${
                    activeImage === val.image ? "active_thumb" : ""
                  }`}
                >
                  <img
                    src={process.env.REACT_APP_IMG_URL + val?.image}
                    alt="Product Thumbnail"
                  />
                </div>
              </SwiperSlide>
            ))}

          {Number(product?.variant_type_id) === variant_type.Double &&
            selectedVariant?.Product_Variant?.Product_Images?.map(
              (val, index) => (
                <SwiperSlide
                  key={index}
                  onClick={() => setActiveImage(val.image)}
                >
                  <div
                    className={`img_holder ${
                      activeImage === val.image ? "active_thumb" : ""
                    }`}
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + val?.image}
                      alt="Product Thumbnail"
                    />
                  </div>
                </SwiperSlide>
              ),
            )}

          {Number(product?.variant_type_id) === variant_type.Triple &&
            selectedVariant?.Double_Variant?.Product_Variant?.Product_Images?.map(
              (val, index) => (
                <SwiperSlide
                  key={index}
                  onClick={() => setActiveImage(val.image)}
                >
                  <div
                    className={`img_holder ${
                      activeImage === val.image ? "active_thumb" : ""
                    }`}
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + val?.image}
                      alt="Product Thumbnail"
                    />
                  </div>
                </SwiperSlide>
              ),
            )}
        </Swiper>
      </div>
    </section>
  );
}

export default Product_details_swiper;
